export default {
  updateName (state, value) {
    state.name = value
  },
  updateDocument (state, value) {
    state.document = value
  },
  updatePhone (state, value) {
    state.phone = value
  },
  updateEmail (state, value) {
    state.email = value
  },
  toggleLoadingEmail (state, value) {
    state.loadingEmail = value
  }
}



// WEBPACK FOOTER //
// ./src/store/cantAccess/mutations.js